import React from "react";
import "./Filter.css";

const Filters = ({ 
  addresses, 
  addressFilter, 
  setAddressFilter, 
  availability, 
  setAvailability 
}) => {
  return (
    <div className="filters-section-basic">
      {/* 👇 العنوان */}
      <h3> Billboards</h3>

      {/* 👇 الجملة التعريفية */}
      <p className="filters-intro">
        Use the options below to narrow down your billboard search.
      </p>

      {/* 👇 الفلاتر */}
      <div className="filter-row">
        <div className="filter-item-basic">
          <label className="filter-label">Address :</label>
          <select
            value={addressFilter}
            onChange={(e) => setAddressFilter(e.target.value)}
            className="filter-select-basic"
          >
            <option value="">All addresses</option>
            {addresses.map((a) => (
              <option key={a.id} value={a.name}>
                {a.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item-basic">
          <label className="filter-label">Availability :</label>
          <select
            value={availability}
            onChange={(e) => setAvailability(e.target.value)}
            className="filter-select-basic"
          >
            <option value="all">All</option>
            <option value="available">Available</option>
            <option value="booked">Booked</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Filters;
